import axios from 'axios';
import settings from './settings';
import store from '..';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
  list: [],
  take: 25,
  search: "",
  columns : [
    {
        table: "text_blocks",
        direction : "ASC",
        direction_pos : 0,
      label: "name",
      key: "name",
    },
    {
        table: "text_blocks",
        direction : "ASC",
        direction_pos : 0,
      label: "type",
      key: "type",
    },
    {
        table: "text_blocks",
        direction : "ASC",
        direction_pos : 0,
      label: "subtype",
      key: "subtype",
    },
  ],
  clear: false,
  loading: true,
  loadingMore: false,
  allLoaded: false,
  addNew: false,
  searchkeys: ["name", "type", "subtype", "text"],
  types: ["orders", "offers", "invoices", "releases", "purchases"],
  workingOn: [],
  isSaving: false,
  openModal: false,
  infinity : {
      active : false,
  },
  pagination: {
    currentPage: 1,
    totalPageCount: 0,
    pagesize: 5
},
meta : {},
})

// getters
const getters = {
  isWorkingOn: (state) => (id) => {
    var index = state.workingOn.findIndex(id);
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  }
}

// actions
const actions = {
  async store({ commit, state, rootState }, data) {
    commit("isSaving", true);
    await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/textblocks", data).then(response => {
      commit("store", response.data.data);
    })
    commit("isSaving", false);
  },
  async update({ commit, state, rootState }, data) {
    commit("workingOn", { id: data.id, status: true });
    await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/textblocks/" + data.id, data).then(response => {
      commit("update", response.data.data);
    })
    commit("workingOn", { id: data.id, status: false });
  },
  async load({ commit, state, rootState }, page = 1) {
    commit("skip", (page - 1) * state.take);
    if (state.allLoaded == false) {
      if (state.clear == true) {
        var skip = 0;
      } else {
        var skip = state.list.length;
      }
      await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/textblocks", { params: { skip: skip, take: state.take, search: state.search, columns: state.searchkeys, table_columns : state.columns } }).then((response) => {
        commit("set", response.data.data);
        commit("pagination", _.get(response, "data.meta.pagination", {total: 0, take: state.take}))
        commit("loading", false);
      })
    }
  },
  async delete({ commit, state, rootState }, data) {
    axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/textblocks/" + data.id).then((response) => {
      commit("removeBlock", state.list.findIndex(item => item.id == data.id));
    });
  }
}

// mutations
const mutations = {
    pagination(state, object){
        state.meta = object;
        if(state.skip <= 0){
            state.pagination.currentPage = 1;
        }else{
           state.pagination.currentPage = (state.skip / state.take) + 1;
        }
            state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
            if(state.infinity.active == true && state.meta.total <= state.skip){
                state.allLoaded = true;
            }
      },
      skip(state, skip){
          state.skip = skip;
      },
  clean(state) {
    state.list = [];
  },
  workingOn(state, data) {
    var index = state.list.findIndex(item => item.id == data.id);
    if (index > -1) {
      state.list[index].working = data.status;
    }
  },
  store(state, block) {
      var index = state.list.findIndex(item => item.id == block.id);
      if(index == -1){
          state.list.unshift(block);
      }
  },
  update(state, block) {
    var index = state.list.findIndex(item => item.id == block.id);
    if (index > -1) {
      state.list[index] = block;
    }else{
        state.list.unshift(block);
    }
  },
  new(state, data) {
    state.list.unshift(data);
  },
  removeBlock(state, index) {
      if(index > -1){
          state.list.splice(index, 1);
      }
  },
  removeItem(state, element){
      var index = state.list.findIndex(item => item.id == element.id);
      if(index > -1){
          state.list.splice(index, 1);
      }
  },
  set(state, list){
    if(list == undefined || list.length <= 0){
      state.allLoaded = true;
    }
  if (state.infinity.active == true) {
      state.list.push(...list);
  } else {
      state.list = list;
  }
},
  setSearch(state, search) {
    state.loading = true;
    state.allLoaded = false;
    state.search = search;
    state.clear = true;
  },
  setSearchValue(state, value) {
    state.external.orders.search = value;
  },
  loading(state, status) {
    state.loading = status;
  },
  isSaving(state, status) {
    state.isSaving = status;
  },
  setOpenModal(state, status){
      state.openModal = status;
  },
    clear(state, status) {
        state.clear = status;
    },
    updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
}
